import { search } from '@martincastroalvarez/runtime';
import { useMemo } from 'react';

/**
 * Hook to get URL parameter value with optional default value
 * @param paramName - The name of the URL parameter to get
 * @param defaultValue - Optional default value if parameter is not present (defaults to empty string)
 * @returns The parameter value or default value
 */
export const useParam = (paramName: string, defaultValue: string = ''): string => {
  return useMemo(() => {
    const params = new URLSearchParams(search());
    return params.get(paramName) ?? defaultValue;
  }, [paramName, defaultValue]);
};
